module.exports = __webpack_public_path__ + "3aa38723.png";